export default "__VITE_ASSET__CVLRgPz7__"